// Shows the label matching the current clip of a compilation video, using start times in data-starts (seconds).
class SVideoClipLabel extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.starts = (this.dataset.starts || '').split(',').map(Number).filter((n) => !Number.isNaN(n));
    this.labels = [...this.querySelectorAll('[data-clip]')];
    const frame = this.closest('[data-clip-frame]');
    const video = frame?.querySelector('video:not([aria-hidden="true"])');
    if (!video || this.labels.length === 0) return;
    const update = () => this.show(this.indexFor(video.currentTime));
    video.addEventListener('timeupdate', update, { signal: this.controller.signal });
    video.addEventListener('seeked', update, { signal: this.controller.signal });
    update();
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  indexFor(time) {
    let index = 0;
    this.starts.forEach((start, i) => {
      if (time >= start) index = i;
    });
    return Math.min(index, this.labels.length - 1);
  }

  show(index) {
    if (index === this.current) return;
    this.current = index;
    this.labels.forEach((label, i) => {
      label.hidden = i !== index;
    });
  }
}

customElements.define('s-video-clip-label', SVideoClipLabel);
